import { Wordmark } from "./Decor";

const FATSECRET_BADGE = "https://platform.fatsecret.com/api/static/images/powered_by_fatsecret_horizontal_brand.svg";

const COLS = [
  {
    title: "Product",
    links: [
      { label: "Features", href: "#features" },
      { label: "Free vs Pro", href: "#pro" },
      { label: "Download", href: "#download" },
      { label: "FAQ", href: "#faq" },
    ],
  },
  {
    title: "Support",
    links: [
      { label: "Help & Feedback", href: "mailto:hello@yetitraining.app" },
      { label: "Privacy Policy", href: "/privacy-policy" },
      { label: "Terms of Service", href: "/terms-of-service" },
      { label: "Account Deletion", href: "/account-deletion" },
    ],
  },
  {
    title: "Release status",
    links: [
      { label: "Android · Google Play", href: "https://play.google.com/store/apps/details?id=com.yetitraining.app", external: true },
      { label: "iOS · App Store pending", href: "#get-aktua", muted: true },
    ],
  },
];

export const Footer = () => (
  <footer className="border-t border-[#D8D1C5] bg-[#FBFAF5]">
    <div className="mx-auto grid max-w-6xl gap-12 px-5 py-16 sm:px-8 md:grid-cols-[1.2fr_2fr]">
      <div>
        <Wordmark />
        <p className="mt-4 max-w-xs text-sm leading-relaxed text-[#65706A]">Fitness tracking that connects what you eat, how you train and how you progress.</p>
        <a href="https://platform.fatsecret.com" target="_blank" rel="noreferrer" className="mt-6 inline-flex rounded-full transition-opacity hover:opacity-75 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2F7555] focus-visible:ring-offset-4" aria-label="Nutrition information provided by fatsecret Platform API" data-testid="fatsecret-attribution">
          <img src={FATSECRET_BADGE} alt="Nutrition information provided by fatsecret Platform API" width="212" height="40" loading="lazy" />
        </a>
      </div>
      <div className="grid gap-10 sm:grid-cols-3">
        {COLS.map((column) => (
          <nav key={column.title} aria-label={column.title}>
            <h3 className="text-xs font-bold uppercase tracking-[0.18em] text-[#87918D]">{column.title}</h3>
            <ul className="mt-4 space-y-1">
              {column.links.map((link) => (
                <li key={link.label}>
                  <a href={link.href} target={link.external ? "_blank" : undefined} rel={link.external ? "noreferrer" : undefined} data-testid={`footer-link-${link.label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/-+$/, "")}`} className={`inline-flex min-h-[40px] items-center text-sm font-medium transition-colors ${link.muted ? "text-[#87918D]" : "text-[#65706A] hover:text-[#2F7555]"}`}>{link.label}</a>
                </li>
              ))}
            </ul>
          </nav>
        ))}
      </div>
    </div>
    <div className="border-t border-[#EEE9DF]"><p className="mx-auto max-w-6xl px-5 py-6 text-xs text-[#87918D] sm:px-8">© 2026 AKTUA. All rights reserved.</p></div>
  </footer>
);
